var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-viewer",on:{"click":_vm.bgClick}},[_c('img',{attrs:{"src":_vm.path},on:{"click":_vm.photoClick}}),(_vm.removable)?_c('button',{staticClass:"remove-btn",on:{"click":_vm.onRemove}},[_vm._v("Remove")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }